import { FC } from 'react'

interface AvatarProps {
  width?: number
  height?: number
  src?: string
  firstName?: string | null
  lastName?: string | null
}

export const Avatar: FC<AvatarProps> = (props) => {
  const firstInitial = props.firstName?.charAt(0).trim() ?? ''
  const lastInitial = props.lastName?.charAt(0).trim() ?? ''
  const initials = `${firstInitial}${lastInitial}`.toUpperCase()

  const width = props.width ?? 32
  const height = props.height ?? 32

  return (
    <div
      className="flex items-center justify-center bg-background-input border border-border rounded-full text-muted-foreground font-medium aspect-square overflow-hidden"
      style={{ width, height }}
    >
      {props.src && (
        <img
          src={props.src}
          alt={`${props.firstName} ${props.lastName}`}
          className="w-full h-full object-center object-cover"
          style={{ width, height }}
        />
      )}

      {!props.src && initials}
    </div>
  )
}
